import { AppFacilities } from "common/components/types";
import { defined, assert } from "common/Support";

let materialAppFacilities: AppFacilities | undefined;

export function setAppFacilities(appFacilities: AppFacilities): void {
    assert(materialAppFacilities === undefined);
    materialAppFacilities = appFacilities;
}

export function getAppFacilities(): AppFacilities {
    return defined(materialAppFacilities);
}
